module.exports = __webpack_public_path__ + "static/media/holly.f125a8f4.jpg";